const AddonHooks = {
    appStateReducer: () => {},
    appStateStore: null
};

export default AddonHooks;
